import { render, staticRenderFns } from "./PurchasesDetail.vue?vue&type=template&id=d0d23c42&scoped=true"
import script from "./PurchasesDetail.vue?vue&type=script&lang=js"
export * from "./PurchasesDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchasesDetail.vue?vue&type=style&index=0&id=d0d23c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d23c42",
  null
  
)

export default component.exports